import React, { useEffect, useState } from "react";
import useSize from "../../../Hooks/useSize.js";
import "../../Styles/globalStyle.css";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function RichTextBox(props) {
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const buildStyle = useBuildStyle();
  
  useEffect(() => {
    props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);

  /*
  useEffect(() => {
    function handleResize() {
      alert("resized to: ", window.innerWidth, "x", window.innerHeight);
    }

    window.addEventListener("resize", handleResize);
  });
 */
  const getStyle = () => {
    var styles = buildStyle(props.style)
    if (props.errors)
      styles["border"] = props.errors.border
    return styles
  };
  return (
    <React.Fragment>
      <textarea
        type="text"
        name={props.data.properties.text.value}
        value={props.data.properties.text.value}
        className="richTextBox"
        draggable={props.draggable}
      onDragStart={(e) => props.onDragStart(e)}
      onClick={props.onClick}
      style={getStyle()}
      id={props.data.id}
      />
      {props.errors && <input readOnly style={props.errors.styles} value={props.errors.value} />}
    </React.Fragment>
  );
}
